import Utils, { getLocalstorage, setLocalStorage } from '../utils';
import store from '../store';
import { commonActionType } from '../actionTypes';
import { removeBlankKeys } from '../components/material-ui/helper';
export const CLIENT_ID_COOKIE_KEY = 'clientId';
export const USER_UUID_COOKIE_KEY = 'userUUID';

export const validateAndSetClientIdCookie = () => {
  let clientIdCookie = Utils.getCookie(CLIENT_ID_COOKIE_KEY);
  let clientIdLocal = getLocalstorage(CLIENT_ID_COOKIE_KEY);

  // This is added to handle the following case -
  // To update the existing clientId cookie which is currently not secured and no SameSite property is configured.
  // In this case, the clientId in the local storage will be set as the cookie value.
  // Here, we are assuming that the clientID value in localstorage and in cookie will be the same in all cases.
  if (!clientIdCookie && clientIdLocal) {
    setClientIdCookie(clientIdLocal);
    return clientIdLocal;
  }
  let clientId = clientIdLocal || clientIdCookie;
  if (!clientIdCookie && !clientIdLocal) {
    clientId = store.getState().config.clientId || Utils.generateUUID();
    setClientIdCookie(clientId);
  }
  return clientId;
};

export const setClientIdCookie = (cookieValue) => {
  if (cookieValue) {
    Utils.setCookieWithSecureFlag(
      CLIENT_ID_COOKIE_KEY,
      cookieValue,
      'Fri, 31 Dec 9999 23:59:59 GMT',
      process.env.PREACT_APP_COOKIE_BASE_PATH,
      '/'
    );
    store.dispatch({
      type: commonActionType.STORE_DATA,
      payload: removeBlankKeys({
        clientId: cookieValue,
      }),
    });
    setLocalStorage(CLIENT_ID_COOKIE_KEY, cookieValue);
  }
};



// WEBPACK FOOTER //
// ./components/transaction/src/tracking/helper.js